export default __webpack_public_path__ + "static/media/Company_profile_Fincantieri_Si_eng.a28aed8b.pdf";